import { hostAddress } from 'data/helpers'

export function fetchSSE({ path, values, onProgress, onComplete, onError, abortController }) {
  const controller = abortController || new AbortController()

  const run = async () => {
    const response = await fetch(hostAddress(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(values),
      signal: controller.signal,
    })

    if (!response.ok) {
      const error = new Error(`HTTP error! status: ${response.status}`)
      error.status = response.status
      throw error
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    let buffer = ''
    let reading = true

    while (reading) {
      const { done, value } = await reader.read()
      if (done) {
        reading = false
        continue
      }

      buffer += decoder.decode(value, { stream: true })

      const lines = buffer.split('\n')
      buffer = lines.pop()

      let currentEvent = null
      for (const line of lines) {
        if (line.startsWith('event: ')) {
          currentEvent = line.slice(7).trim()
        } else if (line.startsWith('data: ') && currentEvent) {
          const jsonStr = line.slice(6)
          try {
            const data = JSON.parse(jsonStr)
            if (currentEvent === 'progress') {
              onProgress?.(data)
            } else if (currentEvent === 'complete') {
              onComplete?.(data)
            } else if (currentEvent === 'error') {
              onError?.(data)
            }
          } catch {
            // Skip malformed JSON
          }
          currentEvent = null
        } else if (line === '') {
          currentEvent = null
        }
      }
    }
  }

  return {
    promise: run(),
    abort: () => controller.abort(),
  }
}
